import React from 'react'
import { Box, Grid } from "@material-ui/core"
import { cardsStyles } from './styles'

const ModulesCards = ({ info, modules }) => {
  const classes = cardsStyles()
  const tacticas = info.filter(action => action.tipo === 'Tácticas')
  const estrategicas = info.filter(action => action.tipo === 'Estrátegicas')
  return (
    <Box style={{ padding: '40px' }}>
      <h3 className={classes.title}>Total acciones por tipo y módulo</h3>
      <Box className={classes.sectionContainer}>
        <h3 className={classes.titleSection}>Tácticas</h3>
        <Grid
        container
          sx={12}
          spacing={3}
        >
          {modules.map((module) => (
            <Grid item xs={3}>
                <Box className={classes.cardContainer}>
                  <span className={classes.icon}>#</span>
                  <div className={classes.textContainer}>
                    <p className={classes.titleCard}>
                    {module}
                  </p>
                  {/* {tacticasModules.includes(module) ? <p className={classes.amount}>{tacticas.map(action => action.modulo === module && action.totalAcciones)}</p> : <p className={classes.amount}>0</p> } */}
                  <p className={classes.amount}>{tacticas.filter(action => action.modulo === module)[0]?.totalAcciones || '0'}</p>
                  </div>
                </Box>
          </Grid>
          ))}
      </Grid>
      </Box>
      <Box className={classes.sectionContainer}>
        <h3 className={classes.titleSection}>Estratégicas</h3>
        <Grid
        container
          sx={12}
          spacing={3}
        >
          {modules.map((module) => (
            <Grid item xs={3}>
                <Box className={classes.cardContainer}>
                  <span className={classes.icon}>#</span>
                  <div className={classes.textContainer}>
                    <p className={classes.titleCard}>
                    {module}
                  </p>
                  {/* {estrategicasModules.includes(module) ? <p className={classes.amount}>{estrategicas.map(action => action.modulo === module && action.totalAcciones)}</p> : <p className={classes.amount}>0</p> } */}
                  <p className={classes.amount}>{estrategicas.filter(action => action.modulo === module)[0]?.totalAcciones || '0'}</p>
                  </div>
                </Box>
          </Grid>
          ))}
      </Grid>
      </Box>
    </Box>
  )
}

export default ModulesCards